module.exports = __webpack_public_path__ + "f8b23d5f98fb26db71ccf6a799915d0e.svg";